// RequireAdmin.jsx
import { Navigate, Outlet } from "react-router-dom";

function getTokenWithExpiry(key) {
    const itemStr = localStorage.getItem(key);
    if (!itemStr) return null;
    const item = JSON.parse(itemStr);
    const now = new Date();
    if (now.getTime() > item.expiry) {
        localStorage.removeItem(key);
        return null;
    }
    return item.token;
}

function decodeJwt(token) {
    try {
        const base64Url = token.split(".")[1];
        const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
        const padded = base64.padEnd(
            base64.length + ((4 - (base64.length % 4)) % 4),
            "="
        );
        const json = decodeURIComponent(
            atob(padded)
                .split("")
                .map(
                    (c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2)
                )
                .join("")
        );
        return JSON.parse(json);
    } catch {
        return null;
    }
}

const RequireAdmin = () => {
    const token = getTokenWithExpiry("accessToken");
    if (!token) return <Navigate to="/login" replace />;

    const payload = decodeJwt(token);
    const isAdmin =
        payload?.is_superuser === true && payload?.type === "access";

    return isAdmin ? <Outlet /> : <Navigate to="/403" replace />;
};

export default RequireAdmin;
